(function($) {
	var app = {
	    initSideMenu: function() {
		   $('[data-ip-menu]').on('click', function() {
			  var $this = $(this),
				 $sideMenu = $('.ip-side-menu'),
				 $sideMenuOverlay = $('.ip-side-menu-overlay'),
				 option = $this.data('ip-menu');
			  if (option == 'open') {
				 $sideMenu.addClass('active');
				 $sideMenuOverlay.addClass('active');
			  }
			  if (option == 'close') {
				 $sideMenu.removeClass('active');
				 $sideMenuOverlay.removeClass('active');
			  }
		   });
	    },
	    initNavigation: function() {
		   $('.ip-side-menu-navigation ul li[data-content]').on('click', function() {
			  var $this = $(this);
			  var $content = $this.data('content');
			  var $item = $(this).attr('data-item');
              var $dropdownText  = $('.ip-bo-ft-indicator-list ul li[data-content="' + $content + '"]').text();
			  $('.ip-side-menu').removeClass('active');
			  $('.ip-side-menu-overlay').removeClass('active');
			  $('.ip-side-menu-navigation ul li[data-content]').removeClass('active');
			  $('.ip-side-menu-navigation ul li[data-content="' + $content + '"]').addClass('active');
			  $('.ip-bike-order').removeClass('active');
			  $('.ip-bike-order[data-content="' + $content + '"]').addClass('active');
			  // $('.ip-bo-ft-indicator-list ul').slick('slickGoTo', $item);
              $('.selected-text').text($dropdownText);
		   });
		   $('.ip-bo-ft-indicator-list ul li').on('click', function() {
			  var $this = $(this);
			  var $content = $this.data('content');
			  $('.ip-bo-ft-indicator-list ul li[data-content]').removeClass('active');
			  $('.ip-bo-ft-indicator-list ul li[data-content="' + $content + '"]').addClass('active');
			  $('.ip-side-menu-navigation ul li[data-content]').removeClass('active');
			  $('.ip-side-menu-navigation ul li[data-content="' + $content + '"]').addClass('active');
			  $('.ip-bike-order').removeClass('active');
			  $('.ip-bike-order[data-content="' + $content + '"]').addClass('active');
		   });
	    },
	    initSteps: function() {

           $('.ip-bike-order').each(function(){
               var this_bike = jQuery(this);
               var get_total = this_bike.find('.ip-bo-en-list ul li').length;
               this_bike.find('.ip-bo-bd-main .ip-bo-bd-item[data-step="0' + get_total + '"] .next-step').attr('data-step', '01'); 
           });

           $('.ip-bike-order').each(function(){
              var this_bike = jQuery(this);
              this_bike.find('.ip-bo-bd-btn .next-step:not([data-step="01"])').on('click', function() {
                var $this = $(this);
                var $step = $this.data('step');
                $('.ip-bike-order.active .ip-bo-en-list ul li').removeClass('active');
                $('.ip-bike-order.active .ip-bo-en-list ul li[data-step="' + $step + '"]').addClass('active');
                $('.ip-bike-order.active .ip-bo-bd-item').removeClass('active');
                $('.ip-bike-order.active .ip-bo-bd-item[data-step="' + $step + '"]').addClass('active');
              });
           });

           $('.ip-bike-order').each(function(){
              var this_bike = jQuery(this);
              this_bike.find('.ip-bo-bd-btn.is-back-btn .back-btn').on('click', function() {
                var $this = $(this);
                var $step = $this.data('step');
                $('.ip-bike-order.active .ip-bo-en-list ul li').removeClass('active');
                $('.ip-bike-order.active .ip-bo-en-list ul li[data-step="' + $step + '"]').addClass('active');
                $('.ip-bike-order.active .ip-bo-bd-item').removeClass('active');
                $('.ip-bike-order.active .ip-bo-bd-item[data-step="' + $step + '"]').addClass('active');
              });
           });

           $('.ip-bike-order').each(function(){
              var this_bike = jQuery(this);
              this_bike.find('.ip-bo-en-list ul li').on('click', function() {
                  var $this = $(this);
                  var $step = $this.data('step');
                  $('.ip-bike-order.active  .ip-bo-en-list ul li').removeClass('active');
                  $this.addClass('active');
                  $('.ip-bike-order.active  .ip-bo-bd-item').removeClass('active');
                  $('.ip-bike-order.active  .ip-bo-bd-item[data-step="' + $step + '"]').addClass('active');
              });
            });

            $('.ip-bike-order').each(function(){
              var $this = $(this);
              var $container = $this.find('.ip-bo-bd-container')
              var $submitBtn = $this.find('.purchase-form__actions button.global-btn.submit.js-ajax-add');
              var $lastStep = $this.find('.ip-bo-bd-btn .next-step[data-step="01"]');
              var $backBtn = $this.find('.ip-bo-bd-btn.is-back-btn');
              $submitBtn.addClass('hidden');
              $lastStep.on('click', function() {
                  $submitBtn.removeClass('hidden');
                  $(this).addClass('hidden');
                  $container.addClass('disabled-next');
                  $backBtn.addClass('hidden');
              });
            });

      
	    },
	    initControls: function() {
		   $('.ip-bo-ft-img-container img').each(function() {
			  if ($(this).attr('src') == '') {
				 // $(this).remove();
			  }
		   });

           $('.ip-bike-order').each(function(){

              var this_bike = jQuery(this);
              
              this_bike.find('.ip-bo-bd-btn-picker').each(function() {
                
                  var $this = $(this);
                  var $color = $this.find('button');
                
                  $color.on('click', function() {

                    // Modification To allow in the STEP 06 ADD BASH GUARD FOR PROTECTION  Multiple selection
                    var variant_total_price = 0;

                      var $btn     = $(this);
                      var rawName  = String($btn.attr('data-name') || '');   // as is in the DOM (with spaces, etc.)
                      var normName = $.trim(rawName);                        // Short version to compare logically

                      // Group brothers for data name using TRIM comparison (avoid the bug of spaces)
                      var $groupButtons = this_bike.find('.ip-bo-bd-btn-picker button').filter(function(){
                        return $.trim($(this).attr('data-name') || '') === normName;
                      });

                      // It is an Addon?
                      var isAddon = $btn.attr('js-purchase') === 'addon-variant';

                      // Just the step 06 (accesories) allow multiple selection
                      // We detect it for the unique name of the button in that step
                      var isStep06  = ($btn.attr('name') === 'options-bash-guard-test');
                      var allowMulti = isAddon && isStep06;

                      if (allowMulti) {
                        // Exclusion with "No Accesories"
                        var label = String($btn.val() || $btn.data('accessories') || '').trim().toLowerCase();
                        var isNone = (label === 'no accessories');

                        if (isNone) {
                          // If they Choose "No Accesories" disable the other options in the step 06
                          $groupButtons.not($btn).removeClass('active').find('input.js-addon-variant').prop('checked', false);
                          $btn.addClass('active').find('input.js-addon-variant').prop('checked', true);
                        } else {
                          // If they choose anything else, remove "No Accesories" and alternate this 
                          $groupButtons.filter(function(){
                            var v = String($(this).val() || $(this).data('accessories') || '').trim().toLowerCase();
                            return v === 'no accessories';
                          }).removeClass('active').find('input.js-addon-variant').prop('checked', false);

                          var nowActive = !$btn.hasClass('active');
                          $btn.toggleClass('active', nowActive)
                              .find('input.js-addon-variant').prop('checked', nowActive);
                        }

                        // If the user deselect all options automatically is selected No accesories
                          var hasActive = $groupButtons.filter('.active').length > 0;
                          if (!hasActive) {
                            // Look the button "No Accessories" inside the same group 
                            var $noneBtn = $groupButtons.filter(function () {
                              var v = String($(this).val() || $(this).data('accessories') || '')
                                        .trim().toLowerCase();
                              return v === 'no accessories';
                            }).first();

                            if ($noneBtn.length) {
                              $noneBtn.addClass('active')
                                      .find('input.js-addon-variant').prop('checked', true);
                            } else {
                              // (fallback in case "No Accessories" doesn't exist)
                              $groupButtons.first().addClass('active').find('input').prop('checked', true);
                            }
                          }


                      } else {
                        // SINGLE-SELECT for ALL others steps (includes addon-variant other than 06)
                        $groupButtons.removeClass('active').find('input').prop('checked', false);
                        $btn.addClass('active').find('input').prop('checked', true);
                      }


    
                     this_bike.find('.purchase-form form').each(function(){
    
                       var $generate_selection = '';
                       var this_form = $(this);
    
                       this_form.find('.ip-bo-bd-btn-picker button.active[js-purchase="option"]').each(function( index, value ){
    
                          $generate_selection += '[data-option' + ( index + 1 ) + '="' + $(this).val() + '"]';
                       });
    
                       this_form.find('.purchase-form-select option[selected]').removeAttr('selected');
                       this_form.find('.purchase-form-select option' + $generate_selection).attr('selected', 'selected');
    
                       var $is_available = this_form.find('.purchase-form-select option[selected]').attr('data-available');
                       var $get_price = this_form.find('.purchase-form-select option' + $generate_selection).attr('data-price');

                       function formatCurrency(number){
                          if(number == "") return;
                          number = parseFloat(number).toFixed(2);
                          var n = number.split('').reverse().join("");
                          // console.log(n);
                          var n2 = n.replace(/\d\d\d(?!$)/g, "$&,");    
                          return '$' + n2.split('').reverse().join('');
                       }

                       function addCommas(nStr) {
                         
                          nStr += '';
                          x = nStr.split('.');
                          x1 = x[0];
                          x2 = x.length > 1 ? '.' + x[1] : '';
                          var rgx = /(\d+)(\d{3})/;
                        
                          while (rgx.test(x1)) {
                            
                              x1 = x1.replace(rgx, '$1' + ',' + '$2');
                          }
                        
                          return x1 + x2;
                       }

                       var $product_price = this_form.find('.purchase-form-select option' + $generate_selection).attr('data-price-value');

                       this_bike.find('.add-variants-holder').html('');

                       var counter = 0;

                       this_bike.find('.ip-bo-bd-btn-picker .purchase-option button.active[js-purchase="addon-variant"]').each(function(){

                           counter++;

                           var $variant_price = jQuery(this).attr('data-price-value');

                           variant_total_price = parseInt( variant_total_price ) + parseInt( $variant_price );
                         
                           var $total_product_price = addCommas( ( variant_total_price + parseInt( $product_price ) ).toFixed(2) );

                           $get_price = "<span class='price__amount'><span class='money'>$" + $total_product_price + "</span><!-- /.money --></span>";

                           var $variant_id = jQuery(this).attr('id');

                           this_bike.find('.add-variants-holder').append('<input type="hidden" name="id" min="1" value="' + $variant_id + '">');
                           this_bike.find('.add-variants-holder').append('<input type="hidden" name="quantity" min="1" value="1">');
                       });
    
                       this_bike.find('.ip-bo-en-total-holder .ip-bo-en-total-inner h2').html( $get_price );
    
                       var $get_text = '';
    
                       if( $is_available == 'true' ) {
    
                         $get_text = $('.purchase-form__actions button').attr('data-ordernow-label');
                         this_bike.find('.purchase-form__actions button').removeAttr('disabled');
                         
                       } else {
    
                         $get_text = $('.purchase-form__actions button').attr('data-soldout-label');
                         this_bike.find('.purchase-form__actions button').attr('disabled', 'disabled');
                       }
    
                       this_bike.find('.purchase-form__actions button').text( $get_text );
                     });
                    
                     // console.log($data);
                  });
               });
           });
	    },
	    initResetOptions: function() {
		   $('.ip-bike-order').each(function() {
			  $(this).find('.color-picker').removeClass('active');
			  $(this).find('.color-picker').eq(0).addClass('active');
			  $(this).find('.bike-color').removeClass('active');
			  $(this).find('.bike-color').eq(0).addClass('active');
			  $(this).find('.wheel-picker').removeClass('active');
			  $(this).find('.wheel-picker').eq(0).addClass('active');
			  $(this).find('.wheel-color').removeClass('active');
			  $(this).find('.wheel-color').eq(0).addClass('active');
			  $(this).find('.battery-picker').removeClass('active');
			  $(this).find('.battery-picker').eq(0).addClass('active');
			  $(this).find('.battery').removeClass('active');
			  $(this).find('.battery').eq(0).addClass('active');
			  $(this).find('.seat-picker').removeClass('active');
			  $(this).find('.seat-picker').eq(0).addClass('active');
			  $(this).find('.gearing-picker').removeClass('active');
			  $(this).find('.gearing-picker').eq(0).addClass('active');
			  $(this).find('.storage-picker').removeClass('active');
			  $(this).find('.storage-picker').eq(0).addClass('active');
			  $(this).find('.storage').removeClass('active');
			  $(this).find('.storage').eq(0).addClass('active');
			  $(this).find('.accessories-picker').removeClass('active');
			  $(this).find('.accessories-picker').eq(0).addClass('active');
			  $(this).find('.accessories').removeClass('active');
			  $(this).find('.accessories').eq(0).addClass('active');
		   });
	    },
	    initIndicatorSlide: function() {
		   var $slider = $('.ip-bo-ft-indicator-list ul');
		   $slider.not('.slick-initialized').slick({
			  slidesToShow: 2,
			  slidesToScroll: 1,
			  vertical: true,
			  verticalSwipping: true,
			  dots: false,
			  arrows: false,
			  infinite: true,
			  autoplay: false,
			  autoplaySpeed: 3000,
			  focusOnSelect: true,
		   });
		   $slider.on('beforeChange', function() {
			  var $this = $(this);
			  var $item = $this.find('.slick-slide');
			  var $content = $this.find('li').data('step');
			  if ($item.hasClass('slick-current')) {
				 $('.ip-bike-order[data-content="' + $content + '"]').addClass('active');
			  } else {
				 $('.ip-bike-order').removeClass('active');
			  }
			  // app.initResetOptions();
		   });
	    },

      updateImages: function() {

          $('.ip-bike-order').each(function(){

              var this_bike = jQuery(this);
              
              this_bike.find('.ip-bo-bd-btn-picker .purchase-option button').each(function(){

                  var this_button = $(this);
    
                  this_button.click(function(){
    
                      var check_image = $(this).attr('data-main-image');
                      var get_handle = $(this).attr('data-name').trim();
    
                      if( check_image ) {
                        
                          var get_type = $(this).attr('js-purchase');
    
                          this_bike.find('.ip-bo-ft-img .section__images img[' + get_handle + ']').attr('src', check_image);
    
                          if( get_type == 'addon-variant' ) {
    
                              this_bike.find('.ip-bo-ft-img .section__images img[' + get_handle + ']').addClass('active');
                              this_bike.find('.ip-bo-ft-img .section__images img[' + get_handle + ']').removeAttr('hidden');
                          }
                        
                      } else {
    
                          this_bike.find('.ip-bo-ft-img .section__images img[' + get_handle + ']').attr('hidden');
                          this_bike.find('.ip-bo-ft-img .section__images img[' + get_handle + ']').removeClass('active');
                          this_bike.find('.ip-bo-ft-img .section__images img[' + get_handle + ']').removeAttr('src');
                      }
                  });
              });
          });
      },
      dropdown: function (){
        setTimeout(function(){
           var activeItem = $(".dropdown-menu li.active");
            if (activeItem.length) {
                var selectedText = activeItem.text().trim();
                $(".selected-text").text(selectedText);
            }
        },500);
        $(".dropdown-menu .dropdown-item").click(function(e) {
          e.preventDefault();
          var selectedText = $(this).text();
          $(this).closest(".dropdown").find(".selected-text").text(selectedText);
        });
      },
      fixDefaultImages: function(){
        $('#disctrict-scrambler .ip-bo-ft-img-container img[wheel-color].section__image.active').attr('src', 'https://cld.accentuate.io/9598925930780/1725248715431/scrambler_black_wheels.jpg');
        $('#disctrict-street .ip-bo-ft-img-container img[wheel-color].section__image.active').attr('src', 'https://cld.accentuate.io/9598934057244/1724906234114/District_Black_Wheel.png');
      },
	}
	$(document).ready(function() {
	    app.initSideMenu();
	    app.initNavigation();
	   // app.initSteps();
	    app.initControls();
	    // app.initIndicatorSlide();
      app.updateImages();
      app.dropdown();
      app.fixDefaultImages();
	});
	$(window).on('load', function() {});


  
/* script to put in bottom the floating price in mobile */

function isMobile() {
  return window.innerWidth <= 991;
}

var lastScrollTop = 0;
var totalHolder = document.querySelector('.ip-bo-en-total-holder');

window.addEventListener('scroll', function () {
  if (!isMobile() || !totalHolder) {
    totalHolder.style.position = '';
    return;
  }

  var currentScroll = window.scrollY || document.documentElement.scrollTop;
  var scrollBottom = currentScroll + window.innerHeight;
  var docHeight = document.documentElement.scrollHeight;
  console.log('Height document:', document.documentElement.scrollHeight);


  // If you are going down and reach the bottom → change to relative
  if (currentScroll > lastScrollTop && scrollBottom >= docHeight - 10) {
    totalHolder.style.position = 'relative';
    totalHolder.style.bottom = '50px';
    totalHolder.style.width = '100%';
    totalHolder.style.right = '0';
    totalHolder.style.borderRadius = '0';
    totalHolder.style.textAlign = 'center';
  }

  // If you are going up → come back to fixed
  if (currentScroll < lastScrollTop) {
    totalHolder.style.position = 'fixed';
    totalHolder.style.bottom = '90px';
    totalHolder.style.width = '';
    totalHolder.style.textAlign = '';
    totalHolder.style.right = '2vw';
    totalHolder.style.borderRadius = '10px';
  }

  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
});









  
 })(jQuery);